import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TourStep } from '../components/tour/tour.typings'


export type TourStateType = {
    steps: TourStep[],
    currentStep: number
}

export const initialState: TourStateType = {
    steps: [],
    currentStep: 0
}

const tourSlice = createSlice({
    name: 'tour',
    initialState,
    reducers: {
        setSteps: (state, action: PayloadAction<TourStep[]>) => {
            state.steps = action.payload
        },
        gotoNextStep: (state) => {
            const { steps, currentStep } = state
            if (currentStep === steps.length - 1) return state
            return {
                ...state,
                currentStep: currentStep + 1
            }
        },
        gotoPreviousStep: (state) => {
            const { currentStep } = state
            if (currentStep === 0) return state
            return {
                ...state,
                currentStep: currentStep - 1
            }
        },
        closeTour: (state) => {
            return {
                steps: [],
                currentStep: 0
            }
        }
    }
})

const { actions, reducer } = tourSlice

export const { setSteps, gotoPreviousStep, gotoNextStep, closeTour } = actions

export default reducer



